import Polyfill from './src/Polyfill';

export {
  Polyfill
};



// WEBPACK FOOTER //
// ./node_modules/@aofl/polyfill-service/index.js